/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  CountryCode: { input: any; output: any; }
  /** A date without time (or timezone) */
  Date: { input: any; output: any; }
  Email: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  ShortString: { input: string; output: string; }
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: { input: any; output: any; }
  URL: { input: any; output: any; }
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['ShortString']['output']>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  geo?: Maybe<Scalars['JSON']['output']>;
  pcode?: Maybe<Scalars['ShortString']['output']>;
  region?: Maybe<Scalars['ShortString']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  suite?: Maybe<Scalars['ShortString']['output']>;
  unit?: Maybe<Scalars['ShortString']['output']>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['ShortString']['input']>;
  countryId?: InputMaybe<Scalars['CountryCode']['input']>;
  geo?: InputMaybe<Scalars['JSON']['input']>;
  pcode?: InputMaybe<Scalars['ShortString']['input']>;
  region?: InputMaybe<Scalars['ShortString']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  suite?: InputMaybe<Scalars['ShortString']['input']>;
  unit?: InputMaybe<Scalars['ShortString']['input']>;
};

export type Agent = {
  __typename?: 'Agent';
  address?: Maybe<Address>;
  bank?: Maybe<Bank>;
  comms?: Maybe<Array<Maybe<CommType>>>;
  contacts?: Maybe<Array<Maybe<Scalars['ShortString']['output']>>>;
  creditTs?: Maybe<Scalars['String']['output']>;
  firstEmail?: Maybe<Scalars['ShortString']['output']>;
  firstPhone?: Maybe<Scalars['ShortString']['output']>;
  hours?: Maybe<Scalars['ShortString']['output']>;
  houses?: Maybe<Array<Maybe<Rental>>>;
  id: Scalars['ID']['output'];
  lang?: Maybe<Scalars['ShortString']['output']>;
  margin?: Maybe<Scalars['Float']['output']>;
  memos?: Maybe<Array<Maybe<Memo>>>;
  name?: Maybe<Scalars['ShortString']['output']>;
  note?: Maybe<Scalars['JSON']['output']>;
  options?: Maybe<Array<Maybe<Option>>>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  prices?: Maybe<Array<Maybe<Price>>>;
  saldo?: Maybe<Scalars['Float']['output']>;
};


export type AgentCommsArgs = {
  type?: InputMaybe<Scalars['ShortString']['input']>;
};

export type AgentInput = {
  address?: InputMaybe<AddressInput>;
  bank?: InputMaybe<BankInput>;
  comms?: InputMaybe<Array<InputMaybe<CommTypeInput>>>;
  hours?: InputMaybe<Scalars['ShortString']['input']>;
  houses?: InputMaybe<Array<InputMaybe<RentalInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lang?: InputMaybe<Scalars['ShortString']['input']>;
  memos?: InputMaybe<Array<InputMaybe<MemoInput>>>;
  name?: InputMaybe<Scalars['ShortString']['input']>;
  note?: InputMaybe<Scalars['JSON']['input']>;
};

export type AgentList = {
  __typename?: 'AgentList';
  cursor?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<Agent>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Bank = {
  __typename?: 'Bank';
  BIC?: Maybe<Scalars['ShortString']['output']>;
  IBAN?: Maybe<Scalars['ShortString']['output']>;
  SWIFT?: Maybe<Scalars['ShortString']['output']>;
  address?: Maybe<Address>;
  name?: Maybe<Scalars['ShortString']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type BankInput = {
  BIC?: InputMaybe<Scalars['ShortString']['input']>;
  IBAN?: InputMaybe<Scalars['ShortString']['input']>;
  SWIFT?: InputMaybe<Scalars['ShortString']['input']>;
  address?: InputMaybe<AddressInput>;
  name?: InputMaybe<Scalars['ShortString']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
};

export type BlockedRangeInput = {
  beginDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
  houseId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type BlogPost = {
  __typename?: 'BlogPost';
  date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Maybe<Image>>>;
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  mainImage?: Maybe<Image>;
  regionIds?: Maybe<Array<Maybe<Scalars['ShortString']['output']>>>;
  summary?: Maybe<Scalars['ShortString']['output']>;
  summaryI18n?: Maybe<Scalars['JSON']['output']>;
  template?: Maybe<Scalars['JSON']['output']>;
  text?: Maybe<Scalars['JSON']['output']>;
  textI18n?: Maybe<Scalars['JSON']['output']>;
  title?: Maybe<Scalars['ShortString']['output']>;
  titleI18n?: Maybe<Scalars['JSON']['output']>;
};


export type BlogPostSummaryArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostTextArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostTitleArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlogPostList = {
  __typename?: 'BlogPostList';
  cursor?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<BlogPost>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Client = {
  __typename?: 'Client';
  address?: Maybe<Address>;
  allowMailing?: Maybe<Scalars['Boolean']['output']>;
  bank?: Maybe<Bank>;
  comms?: Maybe<Array<Maybe<CommType>>>;
  creditTs?: Maybe<Scalars['String']['output']>;
  /** normalized first e-mail address in comms */
  email?: Maybe<Scalars['Email']['output']>;
  firstEmail?: Maybe<Scalars['ShortString']['output']>;
  firstPhone?: Maybe<Scalars['ShortString']['output']>;
  fullName?: Maybe<Scalars['ShortString']['output']>;
  id: Scalars['ID']['output'];
  isTravelAgency?: Maybe<Scalars['Boolean']['output']>;
  knowFrom?: Maybe<Scalars['ShortString']['output']>;
  lang?: Maybe<Scalars['ShortString']['output']>;
  latestCapId?: Maybe<Scalars['Int']['output']>;
  memos?: Maybe<Array<Maybe<Memo>>>;
  name?: Maybe<Name>;
  note?: Maybe<Scalars['JSON']['output']>;
  saldo?: Maybe<Scalars['Float']['output']>;
  title: Title;
  titleOther?: Maybe<Scalars['String']['output']>;
};

export type ClientInput = {
  address?: InputMaybe<AddressInput>;
  bank?: InputMaybe<BankInput>;
  comms?: InputMaybe<Array<InputMaybe<CommTypeInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isTravelAgency?: InputMaybe<Scalars['Boolean']['input']>;
  knowFrom?: InputMaybe<Scalars['ShortString']['input']>;
  lang?: InputMaybe<Scalars['ShortString']['input']>;
  memos?: InputMaybe<Array<InputMaybe<MemoInput>>>;
  name?: InputMaybe<NameInput>;
  note?: InputMaybe<Scalars['JSON']['input']>;
};

export type ClientList = {
  __typename?: 'ClientList';
  cursor?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<Client>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Means of communication */
export type CommType = {
  __typename?: 'CommType';
  data?: Maybe<Scalars['ShortString']['output']>;
  note?: Maybe<Scalars['ShortString']['output']>;
  type?: Maybe<Scalars['ShortString']['output']>;
};

/** Means of communication */
export type CommTypeInput = {
  data?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['ShortString']['input']>;
};

export type Content = {
  __typename?: 'Content';
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['JSON']['output']>;
  textI18n?: Maybe<Scalars['JSON']['output']>;
  title?: Maybe<Scalars['ShortString']['output']>;
  titleI18n?: Maybe<Scalars['JSON']['output']>;
};


export type ContentTextArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTitleArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Contract = {
  __typename?: 'Contract';
  acceptLowerDeposit?: Maybe<Scalars['Boolean']['output']>;
  adults?: Maybe<Scalars['Int']['output']>;
  agentId?: Maybe<Scalars['ID']['output']>;
  agentNote?: Maybe<Scalars['String']['output']>;
  agentSaldo?: Maybe<Scalars['Float']['output']>;
  archiveDate?: Maybe<Scalars['Date']['output']>;
  babies?: Maybe<Scalars['Int']['output']>;
  beginDate?: Maybe<Scalars['Date']['output']>;
  capId?: Maybe<Scalars['ID']['output']>;
  capNote?: Maybe<Scalars['String']['output']>;
  client?: Maybe<Client>;
  clientId?: Maybe<Scalars['ID']['output']>;
  clientNote?: Maybe<Scalars['String']['output']>;
  contractDate?: Maybe<Scalars['Date']['output']>;
  createdThroughWebsite?: Maybe<Scalars['Boolean']['output']>;
  discountNote?: Maybe<Scalars['String']['output']>;
  dueDates?: Maybe<Scalars['JSON']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  externalSeller?: Maybe<Scalars['ShortString']['output']>;
  guaranteePaidThere?: Maybe<Scalars['Float']['output']>;
  hasInsurance?: Maybe<Scalars['Boolean']['output']>;
  hasTouristTax?: Maybe<Scalars['Boolean']['output']>;
  house?: Maybe<Rental>;
  houseId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insuranceGuests?: Maybe<Array<Maybe<Guest>>>;
  isExternalSeller?: Maybe<Scalars['Boolean']['output']>;
  isMailingToClientDisabled?: Maybe<Scalars['Boolean']['output']>;
  isOverdue?: Maybe<Scalars['Boolean']['output']>;
  kids?: Maybe<Scalars['Int']['output']>;
  needsGuaranteeReturn?: Maybe<Scalars['Boolean']['output']>;
  needsGuaranteeToBePaid?: Maybe<Scalars['Boolean']['output']>;
  needsVoucher?: Maybe<Scalars['Boolean']['output']>;
  optionExpiryDate?: Maybe<Scalars['Date']['output']>;
  optionNote?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<Option>>>;
  paid?: Maybe<Scalars['Float']['output']>;
  pets?: Maybe<Scalars['Int']['output']>;
  petsNote?: Maybe<Scalars['String']['output']>;
  prices?: Maybe<Scalars['JSON']['output']>;
  rentalFees?: Maybe<Scalars['JSON']['output']>;
  saldo?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<ContractStatus>;
  voucherSent?: Maybe<Scalars['Boolean']['output']>;
};

export type ContractInput = {
  acceptLowerDeposit?: InputMaybe<Scalars['Boolean']['input']>;
  adults?: InputMaybe<Scalars['Int']['input']>;
  agentId?: InputMaybe<Scalars['ID']['input']>;
  agentNote?: InputMaybe<Scalars['String']['input']>;
  archiveDate?: InputMaybe<Scalars['Date']['input']>;
  babies?: InputMaybe<Scalars['Int']['input']>;
  beginDate?: InputMaybe<Scalars['Date']['input']>;
  capId?: InputMaybe<Scalars['ID']['input']>;
  capNote?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  clientNote?: InputMaybe<Scalars['String']['input']>;
  contractDate?: InputMaybe<Scalars['Date']['input']>;
  createdThroughWebsite?: InputMaybe<Scalars['Boolean']['input']>;
  discountNote?: InputMaybe<Scalars['String']['input']>;
  dueDates?: InputMaybe<Scalars['JSON']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  externalSeller?: InputMaybe<Scalars['ShortString']['input']>;
  hasInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  hasTouristTax?: InputMaybe<Scalars['Boolean']['input']>;
  houseId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  insuranceGuests?: InputMaybe<Array<InputMaybe<GuestInput>>>;
  isMailingToClientDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  kids?: InputMaybe<Scalars['Int']['input']>;
  needsGuaranteeReturn?: InputMaybe<Scalars['Boolean']['input']>;
  needsGuaranteeToBePaid?: InputMaybe<Scalars['Boolean']['input']>;
  needsVoucher?: InputMaybe<Scalars['Boolean']['input']>;
  optionExpiryDate?: InputMaybe<Scalars['Date']['input']>;
  optionNote?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<OptionInput>>>;
  pets?: InputMaybe<Scalars['Int']['input']>;
  petsNote?: InputMaybe<Scalars['String']['input']>;
  rentalFees?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<ContractStatus>;
  voucherSent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContractList = {
  __typename?: 'ContractList';
  cursor?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<Contract>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum ContractStatus {
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Confirmed = 'CONFIRMED',
  Option = 'OPTION'
}

/** Distance to interesting things */
export type Distance = {
  __typename?: 'Distance';
  /** Distance in km */
  km?: Maybe<Scalars['Float']['output']>;
  /** Distance in min */
  min?: Maybe<Scalars['Float']['output']>;
  /** Name of thing */
  name?: Maybe<Scalars['ShortString']['output']>;
  /** More special distance/time, or extra explanation */
  note?: Maybe<Scalars['JSON']['output']>;
  /** More special distance/time, or extra explanation */
  noteI18n?: Maybe<Scalars['JSON']['output']>;
  /** Time on foot, car, ... */
  timeId?: Maybe<Scalars['ID']['output']>;
  typeId?: Maybe<Scalars['ID']['output']>;
};


/** Distance to interesting things */
export type DistanceNoteArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Distance to interesting things */
export type DistanceInput = {
  /** Distance in km */
  km?: InputMaybe<Scalars['Float']['input']>;
  /** Distance in min */
  min?: InputMaybe<Scalars['Float']['input']>;
  /** Name of thing */
  name?: InputMaybe<Scalars['ShortString']['input']>;
  noteI18n?: InputMaybe<I18nStringInput>;
  /** Time on foot, car, ... */
  timeId?: InputMaybe<Scalars['ID']['input']>;
  typeId?: InputMaybe<Scalars['ID']['input']>;
};

export type EmailInput = {
  email?: InputMaybe<Scalars['Email']['input']>;
  subject?: InputMaybe<Scalars['ShortString']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type EmailText = {
  __typename?: 'EmailText';
  body?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['ShortString']['output']>;
};

export type Equipment = {
  __typename?: 'Equipment';
  count?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['ID']['output']>;
};

export type EquipmentInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['ID']['input']>;
};

export type Guest = {
  __typename?: 'Guest';
  birthYear?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type GuestInput = {
  birthYear?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** A rental property */
export type House = {
  __typename?: 'House';
  /** From what time available */
  accessTime?: Maybe<Scalars['ShortString']['output']>;
  agentChanges?: Maybe<Scalars['JSON']['output']>;
  bathroomCount?: Maybe<Scalars['Int']['output']>;
  bedroomCount?: Maybe<Scalars['Int']['output']>;
  blockedRanges?: Maybe<Scalars['JSON']['output']>;
  /** Possible capacity, from beds */
  calcCapacity?: Maybe<Scalars['Int']['output']>;
  /** Allowed capacity by owner */
  capacity?: Maybe<Scalars['Int']['output']>;
  category?: Maybe<Scalars['Float']['output']>;
  city?: Maybe<Scalars['ShortString']['output']>;
  countryId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  description?: Maybe<Scalars['JSON']['output']>;
  descriptionI18n?: Maybe<Scalars['JSON']['output']>;
  distances?: Maybe<Array<Maybe<Distance>>>;
  domainId?: Maybe<Scalars['ID']['output']>;
  domainName?: Maybe<Scalars['ShortString']['output']>;
  extras?: Maybe<Array<Maybe<Option>>>;
  features?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  filterCounters?: Maybe<HouseFilterCounters>;
  geo?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  guarantee?: Maybe<Scalars['Float']['output']>;
  hours?: Maybe<Scalars['ShortString']['output']>;
  icons?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Maybe<Image>>>;
  isFree?: Maybe<Scalars['Boolean']['output']>;
  isNew?: Maybe<Scalars['Boolean']['output']>;
  isPromo?: Maybe<Scalars['Boolean']['output']>;
  /** By what time to leave */
  leaveTime?: Maybe<Scalars['ShortString']['output']>;
  livingSurface?: Maybe<Scalars['Int']['output']>;
  localTax?: Maybe<Scalars['Boolean']['output']>;
  mainImage?: Maybe<Image>;
  metaDescription?: Maybe<Scalars['JSON']['output']>;
  metaDescriptionI18n?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['ShortString']['output']>;
  payThere?: Maybe<Scalars['Boolean']['output']>;
  petsAllowed?: Maybe<Scalars['Boolean']['output']>;
  petsMax?: Maybe<Scalars['Int']['output']>;
  placeName?: Maybe<Scalars['ShortString']['output']>;
  prices?: Maybe<Array<Maybe<HousePrice>>>;
  promotions?: Maybe<Array<Maybe<PromotionRule>>>;
  province?: Maybe<Scalars['ShortString']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  regionId?: Maybe<Scalars['ID']['output']>;
  reviews?: Maybe<Array<Maybe<Review>>>;
  rooms?: Maybe<Array<Maybe<Room>>>;
  score?: Maybe<Scalars['ShortString']['output']>;
  slogan?: Maybe<Scalars['JSON']['output']>;
  sloganI18n?: Maybe<Scalars['JSON']['output']>;
  slug?: Maybe<Scalars['ID']['output']>;
  specials?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  street?: Maybe<Scalars['ShortString']['output']>;
  switchDay?: Maybe<Scalars['Int']['output']>;
  taxCategory?: Maybe<Scalars['Int']['output']>;
  taxPlatformId?: Maybe<Scalars['Int']['output']>;
  tips?: Maybe<Scalars['JSON']['output']>;
  tipsI18n?: Maybe<Scalars['JSON']['output']>;
  totalSurface?: Maybe<Scalars['Int']['output']>;
  type: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['Timestamp']['output']>;
  url?: Maybe<Scalars['JSON']['output']>;
  urlI18n?: Maybe<Scalars['JSON']['output']>;
};


/** A rental property */
export type HouseDescriptionArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A rental property */
export type HouseMetaDescriptionArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A rental property */
export type HouseSloganArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A rental property */
export type HouseTipsArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A rental property */
export type HouseUrlArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HouseDomain = {
  __typename?: 'HouseDomain';
  address?: Maybe<Address>;
  agentId?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['JSON']['output']>;
  descriptionI18n?: Maybe<Scalars['JSON']['output']>;
  distances?: Maybe<Array<Maybe<Distance>>>;
  icons?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Maybe<Image>>>;
  keyInfo?: Maybe<KeyInfo>;
  mainImage?: Maybe<Image>;
  regionId?: Maybe<Scalars['ID']['output']>;
  slogan?: Maybe<Scalars['JSON']['output']>;
  sloganI18n?: Maybe<Scalars['JSON']['output']>;
  title?: Maybe<Scalars['JSON']['output']>;
  titleI18n?: Maybe<Scalars['JSON']['output']>;
};


export type HouseDomainDescriptionArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HouseDomainSloganArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HouseDomainTitleArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HouseDomainInput = {
  address?: InputMaybe<AddressInput>;
  agentId?: InputMaybe<Scalars['ID']['input']>;
  descriptionI18n?: InputMaybe<I18nStringInput>;
  distances?: InputMaybe<Array<InputMaybe<DistanceInput>>>;
  icons?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  images?: InputMaybe<Array<InputMaybe<ImageInput>>>;
  keyInfo?: InputMaybe<KeyInfoInput>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
  sloganI18n?: InputMaybe<I18nStringInput>;
  titleI18n: I18nStringInput;
};

export type HouseDomainList = {
  __typename?: 'HouseDomainList';
  cursor?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<HouseDomain>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** A rental property filter counters */
export type HouseFilterCounters = {
  __typename?: 'HouseFilterCounters';
  features?: Maybe<Scalars['JSON']['output']>;
  priceBelow?: Maybe<Scalars['JSON']['output']>;
  specials?: Maybe<Scalars['JSON']['output']>;
};

export type HouseList = {
  __typename?: 'HouseList';
  cursor?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<House>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type HousePrice = {
  __typename?: 'HousePrice';
  buy?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  /** Margin percentage */
  margin?: Maybe<Scalars['Float']['output']>;
  sell?: Maybe<Scalars['Float']['output']>;
};

export type HousePriceInput = {
  buy?: InputMaybe<Scalars['Float']['input']>;
  date: Scalars['Date']['input'];
  /** Margin percentage */
  margin?: InputMaybe<Scalars['Float']['input']>;
  sell?: InputMaybe<Scalars['Float']['input']>;
};

export type HouseTypeDesc = {
  __typename?: 'HouseTypeDesc';
  houseType?: Maybe<Scalars['ShortString']['output']>;
  text?: Maybe<Scalars['JSON']['output']>;
  textI18n?: Maybe<Scalars['JSON']['output']>;
};


export type HouseTypeDescTextArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};

export type I18nListInput = {
  de?: InputMaybe<Array<InputMaybe<Scalars['ShortString']['input']>>>;
  en?: InputMaybe<Array<InputMaybe<Scalars['ShortString']['input']>>>;
  fr?: InputMaybe<Array<InputMaybe<Scalars['ShortString']['input']>>>;
  nl?: InputMaybe<Array<InputMaybe<Scalars['ShortString']['input']>>>;
};

export type I18nStringInput = {
  de?: InputMaybe<Scalars['JSON']['input']>;
  en?: InputMaybe<Scalars['JSON']['input']>;
  fr?: InputMaybe<Scalars['JSON']['input']>;
  nl?: InputMaybe<Scalars['JSON']['input']>;
};

export type Image = {
  __typename?: 'Image';
  alt?: Maybe<Scalars['ShortString']['output']>;
  blurhash?: Maybe<Scalars['ShortString']['output']>;
  h?: Maybe<Scalars['Int']['output']>;
  /** use as main image */
  isMain?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Scalars['ShortString']['output']>;
  /** show online */
  show?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Array<Scalars['ID']['output']>>;
  title?: Maybe<Scalars['ShortString']['output']>;
  upload?: Maybe<Upload>;
  url?: Maybe<Scalars['URL']['output']>;
  w?: Maybe<Scalars['Int']['output']>;
};

export type ImageInput = {
  alt?: InputMaybe<Scalars['ShortString']['input']>;
  /** use as main image */
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['ShortString']['input']>;
  /** show online */
  show?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['ShortString']['input']>;
  uploadId?: InputMaybe<Scalars['ID']['input']>;
  url?: InputMaybe<Scalars['URL']['input']>;
};

export type InstagramCreds = {
  __typename?: 'InstagramCreds';
  accessToken?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type InstagramPost = {
  __typename?: 'InstagramPost';
  instagramUrl?: Maybe<Scalars['URL']['output']>;
  url?: Maybe<Scalars['URL']['output']>;
};

export type JsonList = {
  __typename?: 'JSONList';
  cursor?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type KeyInfo = {
  __typename?: 'KeyInfo';
  address?: Maybe<Address>;
  info?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type KeyInfoInput = {
  address?: InputMaybe<AddressInput>;
  info?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type LandingPage = {
  __typename?: 'LandingPage';
  houseId?: Maybe<Scalars['ShortString']['output']>;
  id: Scalars['Int']['output'];
  imageId?: Maybe<Scalars['ShortString']['output']>;
  isOnline: Scalars['Boolean']['output'];
  metaDesc?: Maybe<Scalars['ShortString']['output']>;
  metaDescI18n?: Maybe<Scalars['JSON']['output']>;
  metaKeywords?: Maybe<Scalars['ShortString']['output']>;
  metaKeywordsI18n?: Maybe<Scalars['JSON']['output']>;
  metaTitle?: Maybe<Scalars['ShortString']['output']>;
  metaTitleI18n?: Maybe<Scalars['JSON']['output']>;
  redirectId?: Maybe<Scalars['ShortString']['output']>;
  redirectUrl?: Maybe<Scalars['URL']['output']>;
  redirectUrlI18n?: Maybe<Scalars['JSON']['output']>;
  regionId?: Maybe<Scalars['ShortString']['output']>;
  search?: Maybe<LandingPageSearchType>;
  template?: Maybe<Scalars['JSON']['output']>;
  url?: Maybe<Scalars['ShortString']['output']>;
  urlI18n?: Maybe<Scalars['JSON']['output']>;
};


export type LandingPageMetaDescArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LandingPageMetaKeywordsArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LandingPageMetaTitleArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LandingPageUrlArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LandingPageInput = {
  houseId?: InputMaybe<Scalars['ShortString']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imageId?: InputMaybe<Scalars['ShortString']['input']>;
  isOnline: Scalars['Boolean']['input'];
  metaDescI18n?: InputMaybe<I18nStringInput>;
  metaKeywordsI18n?: InputMaybe<I18nStringInput>;
  metaTitleI18n?: InputMaybe<I18nStringInput>;
  redirectId?: InputMaybe<Scalars['ShortString']['input']>;
  redirectUrlI18n?: InputMaybe<I18nStringInput>;
  regionId?: InputMaybe<Scalars['ShortString']['input']>;
  search?: InputMaybe<LandingPageSearchInputType>;
  template?: InputMaybe<Scalars['JSON']['input']>;
  urlI18n?: InputMaybe<LandingPageUrlInput>;
};

export type LandingPageList = {
  __typename?: 'LandingPageList';
  cursor?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<LandingPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type LandingPageSearchInputType = {
  features?: InputMaybe<Scalars['JSON']['input']>;
  houseType?: InputMaybe<Scalars['ShortString']['input']>;
  priceRange?: InputMaybe<Scalars['ShortString']['input']>;
  region?: InputMaybe<Array<InputMaybe<Scalars['ShortString']['input']>>>;
  size?: InputMaybe<Scalars['Int']['input']>;
  specials?: InputMaybe<Scalars['JSON']['input']>;
};

export type LandingPageSearchType = {
  __typename?: 'LandingPageSearchType';
  features?: Maybe<Scalars['JSON']['output']>;
  houseType?: Maybe<Scalars['ShortString']['output']>;
  priceRange?: Maybe<Scalars['ShortString']['output']>;
  region?: Maybe<Array<Maybe<Scalars['ShortString']['output']>>>;
  size?: Maybe<Scalars['Int']['output']>;
  specials?: Maybe<Scalars['JSON']['output']>;
};

/** LandingPageUrlInput */
export type LandingPageUrlInput = {
  de?: InputMaybe<Scalars['ShortString']['input']>;
  en?: InputMaybe<Scalars['ShortString']['input']>;
  fr?: InputMaybe<Scalars['ShortString']['input']>;
  nl?: InputMaybe<Scalars['ShortString']['input']>;
};

export type Memo = {
  __typename?: 'Memo';
  email?: Maybe<EmailText>;
  memo?: Maybe<Scalars['JSON']['output']>;
  ts?: Maybe<Scalars['Timestamp']['output']>;
};

export type MemoInput = {
  email?: InputMaybe<Scalars['ShortString']['input']>;
  memo?: InputMaybe<Scalars['JSON']['input']>;
  ts?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type Meta = {
  __typename?: 'Meta';
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  updatedAt?: Maybe<Scalars['Timestamp']['output']>;
  user?: Maybe<PublicUser>;
};

export type Name = {
  __typename?: 'Name';
  first?: Maybe<Scalars['ShortString']['output']>;
  full?: Maybe<Scalars['ShortString']['output']>;
  last?: Maybe<Scalars['ShortString']['output']>;
};

export type NameInput = {
  first?: InputMaybe<Scalars['ShortString']['input']>;
  full?: InputMaybe<Scalars['ShortString']['input']>;
  last?: InputMaybe<Scalars['ShortString']['input']>;
};

export type NewsletterInput = {
  email?: InputMaybe<Scalars['Email']['input']>;
  firstName?: InputMaybe<Scalars['ShortString']['input']>;
  lang?: InputMaybe<Scalars['ShortString']['input']>;
  lastName?: InputMaybe<Scalars['ShortString']['input']>;
};

export type Option = {
  __typename?: 'Option';
  condition?: Maybe<OptionCondition>;
  /** Used in contract options */
  count?: Maybe<Scalars['Int']['output']>;
  /** The maximum number you can order of this extra */
  max?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['ShortString']['output']>;
  optionId?: Maybe<Scalars['ID']['output']>;
  /** Recurrency of extra cost */
  per?: Maybe<Per>;
  /** deprecated, use `per` */
  perWeek?: Maybe<Scalars['Boolean']['output']>;
  /** Is this extra related to number of pets */
  pet?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  /** Is this extra always included */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** deprecated, not used */
  toList?: Maybe<Scalars['Boolean']['output']>;
};

export enum OptionCondition {
  BringOwn = 'bringOwn',
  Included = 'included',
  PayInAdvance = 'payInAdvance',
  PayThere = 'payThere'
}

export type OptionInput = {
  condition?: InputMaybe<OptionCondition>;
  /** Used in contract options */
  count?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum number you can order of this extra */
  max?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['ShortString']['input']>;
  optionId: Scalars['ID']['input'];
  /** Recurrency of extra cost */
  per?: InputMaybe<Per>;
  /** Is the price payable per week? */
  perWeek?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this extra related to number of pets */
  pet?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  /** Is this extra always included */
  required?: InputMaybe<Scalars['Boolean']['input']>;
  toList?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OutboxEmail = {
  __typename?: 'OutboxEmail';
  data?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Float']['output'];
  state?: Maybe<Scalars['ShortString']['output']>;
  to?: Maybe<Scalars['Email']['output']>;
  ts?: Maybe<Scalars['ShortString']['output']>;
  type?: Maybe<Scalars['ID']['output']>;
};

export type OutboxEmailList = {
  __typename?: 'OutboxEmailList';
  cursor?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<OutboxEmail>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** The house owner */
export type Owner = {
  __typename?: 'Owner';
  address?: Maybe<Address>;
  comm?: Maybe<Array<Maybe<CommType>>>;
  name?: Maybe<Scalars['ShortString']['output']>;
};

/** The house owner */
export type OwnerInput = {
  address?: InputMaybe<AddressInput>;
  name?: InputMaybe<Scalars['ShortString']['input']>;
};

export type Payment = {
  __typename?: 'Payment';
  agentId?: Maybe<Scalars['ID']['output']>;
  amount: Scalars['Float']['output'];
  chargeId?: Maybe<Scalars['ID']['output']>;
  contractId?: Maybe<Scalars['ID']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  expireTs?: Maybe<Scalars['Date']['output']>;
  fmId?: Maybe<Scalars['ShortString']['output']>;
  id: Scalars['ID']['output'];
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Scalars['ShortString']['output']>;
  pendingAmount: Scalars['Float']['output'];
  status?: Maybe<PaymentStatus>;
  stripe?: Maybe<Scalars['JSON']['output']>;
};

export type PaymentInfo = {
  __typename?: 'PaymentInfo';
  acceptLowerDeposit?: Maybe<Scalars['Boolean']['output']>;
  adults?: Maybe<Scalars['Int']['output']>;
  agentId?: Maybe<Scalars['ID']['output']>;
  archiveDate?: Maybe<Scalars['Date']['output']>;
  babies?: Maybe<Scalars['Int']['output']>;
  beginDate?: Maybe<Scalars['Date']['output']>;
  capId?: Maybe<Scalars['ID']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  clientName?: Maybe<Scalars['ShortString']['output']>;
  contractDate?: Maybe<Scalars['Date']['output']>;
  createdThroughWebsite?: Maybe<Scalars['Boolean']['output']>;
  depositTotal?: Maybe<Scalars['Float']['output']>;
  dueDates?: Maybe<Scalars['JSON']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  guaranteePayNow?: Maybe<Scalars['Float']['output']>;
  hasInsurance?: Maybe<Scalars['Boolean']['output']>;
  houseId?: Maybe<Scalars['ID']['output']>;
  houseName?: Maybe<Scalars['ShortString']['output']>;
  id: Scalars['ID']['output'];
  insuranceToPay?: Maybe<Scalars['Float']['output']>;
  isOverdue?: Maybe<Scalars['Boolean']['output']>;
  kids?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['ID']['output']>;
  needsGuaranteeReturn?: Maybe<Scalars['Boolean']['output']>;
  needsGuaranteeToBePaid?: Maybe<Scalars['Boolean']['output']>;
  needsVoucher?: Maybe<Scalars['Boolean']['output']>;
  optionExpiryDate?: Maybe<Scalars['Date']['output']>;
  options?: Maybe<Array<Maybe<Option>>>;
  optionsPrice?: Maybe<Scalars['Float']['output']>;
  paid?: Maybe<Scalars['Float']['output']>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  pets?: Maybe<Scalars['Int']['output']>;
  petsNote?: Maybe<Scalars['String']['output']>;
  rentalFees?: Maybe<Scalars['JSON']['output']>;
  saldo?: Maybe<Scalars['Float']['output']>;
  sellRentalAvg?: Maybe<Scalars['Float']['output']>;
  sellTotal?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<ContractStatus>;
};

export type PaymentList = {
  __typename?: 'PaymentList';
  cursor?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<Payment>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum PaymentStatus {
  PaymentStatusBlocked = 'PAYMENT_STATUS_BLOCKED',
  PaymentStatusDone = 'PAYMENT_STATUS_DONE',
  PaymentStatusFailed = 'PAYMENT_STATUS_FAILED',
  PaymentStatusPending = 'PAYMENT_STATUS_PENDING'
}

export enum Per {
  Fixed = 'FIXED',
  Person = 'PERSON',
  Personweek = 'PERSONWEEK',
  Personweekprorated = 'PERSONWEEKPRORATED',
  Week = 'WEEK',
  Weekprorated = 'WEEKPRORATED'
}

export type Price = {
  __typename?: 'Price';
  buy?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  margin?: Maybe<Scalars['Float']['output']>;
  sell?: Maybe<Scalars['Float']['output']>;
};

export type PromotionRule = {
  __typename?: 'PromotionRule';
  discountPercentage?: Maybe<Scalars['Float']['output']>;
  promoEndDate?: Maybe<Scalars['Date']['output']>;
  promoStartDate?: Maybe<Scalars['Date']['output']>;
};

export type PromotionRuleInput = {
  discountPercentage?: InputMaybe<Scalars['Float']['input']>;
  promoEndDate?: InputMaybe<Scalars['Date']['input']>;
  promoStartDate?: InputMaybe<Scalars['Date']['input']>;
};

export type PublicUser = {
  __typename?: 'PublicUser';
  fullName?: Maybe<Scalars['ShortString']['output']>;
  id: Scalars['ID']['output'];
};

export type Redirection = {
  __typename?: 'Redirection';
  currentUrl?: Maybe<Scalars['ShortString']['output']>;
  id: Scalars['ID']['output'];
  oldUrl?: Maybe<Scalars['ShortString']['output']>;
};

export type RedirectionInput = {
  currentUrl?: InputMaybe<Scalars['ShortString']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  oldUrl?: InputMaybe<Scalars['ShortString']['input']>;
};

export type RedirectionList = {
  __typename?: 'RedirectionList';
  cursor?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<Redirection>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Region = {
  __typename?: 'Region';
  countryDesc?: Maybe<Scalars['JSON']['output']>;
  countryDescI18n?: Maybe<Scalars['JSON']['output']>;
  countryTitle?: Maybe<Scalars['JSON']['output']>;
  countryTitleI18n?: Maybe<Scalars['JSON']['output']>;
  houseIds?: Maybe<Array<Maybe<House>>>;
  houseTypeDescs?: Maybe<Array<Maybe<HouseTypeDesc>>>;
  id: Scalars['ID']['output'];
  imageId?: Maybe<Scalars['ID']['output']>;
  regionDesc?: Maybe<Scalars['JSON']['output']>;
  regionDescI18n?: Maybe<Scalars['JSON']['output']>;
  suggestions?: Maybe<Array<Maybe<Suggestion>>>;
  title?: Maybe<Scalars['JSON']['output']>;
  titleI18n?: Maybe<Scalars['JSON']['output']>;
};


export type RegionCountryDescArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RegionCountryTitleArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RegionRegionDescArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RegionTitleArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RegisterInput = {
  acceptLowerDeposit?: InputMaybe<Scalars['Boolean']['input']>;
  adults?: InputMaybe<Scalars['Int']['input']>;
  agentId?: InputMaybe<Scalars['ID']['input']>;
  agentNote?: InputMaybe<Scalars['String']['input']>;
  archiveDate?: InputMaybe<Scalars['Date']['input']>;
  babies?: InputMaybe<Scalars['Int']['input']>;
  beginDate?: InputMaybe<Scalars['Date']['input']>;
  capId?: InputMaybe<Scalars['ID']['input']>;
  capNote?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  clientNote?: InputMaybe<Scalars['String']['input']>;
  contractDate?: InputMaybe<Scalars['Date']['input']>;
  createdThroughWebsite?: InputMaybe<Scalars['Boolean']['input']>;
  discountNote?: InputMaybe<Scalars['String']['input']>;
  dueDates?: InputMaybe<Scalars['JSON']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  externalSeller?: InputMaybe<Scalars['ShortString']['input']>;
  hasInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  hasTouristTax?: InputMaybe<Scalars['Boolean']['input']>;
  houseId?: InputMaybe<Scalars['ID']['input']>;
  insuranceGuests?: InputMaybe<Array<InputMaybe<GuestInput>>>;
  isMailingToClientDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  kids?: InputMaybe<Scalars['Int']['input']>;
  needsVoucher?: InputMaybe<Scalars['Boolean']['input']>;
  optionExpiryDate?: InputMaybe<Scalars['Date']['input']>;
  optionNote?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<OptionInput>>>;
  pets?: InputMaybe<Scalars['Int']['input']>;
  petsNote?: InputMaybe<Scalars['String']['input']>;
  rentalFees?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<ContractStatus>;
  voucherSent?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A rental property */
export type Rental = {
  __typename?: 'Rental';
  /** From what time available */
  accessTime?: Maybe<Scalars['ShortString']['output']>;
  address?: Maybe<Address>;
  agent?: Maybe<Agent>;
  agentChanges?: Maybe<Scalars['JSON']['output']>;
  agentId?: Maybe<Scalars['ID']['output']>;
  agentRef?: Maybe<Scalars['String']['output']>;
  bathroomCount?: Maybe<Scalars['Int']['output']>;
  bedroomCount?: Maybe<Scalars['Int']['output']>;
  blockedRanges?: Maybe<Scalars['JSON']['output']>;
  /** Possible capacity, from beds */
  calcCapacity?: Maybe<Scalars['Int']['output']>;
  /** Allowed capacity by owner */
  capacity?: Maybe<Scalars['Int']['output']>;
  category?: Maybe<Scalars['Float']['output']>;
  contentsOld?: Maybe<Scalars['JSON']['output']>;
  countryId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  dateRanges?: Maybe<Scalars['JSON']['output']>;
  descrNote?: Maybe<Scalars['String']['output']>;
  descriptionI18n?: Maybe<Scalars['JSON']['output']>;
  distances?: Maybe<Array<Maybe<Distance>>>;
  domainId?: Maybe<Scalars['ID']['output']>;
  extras: Array<Maybe<Option>>;
  features?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  guarantee?: Maybe<Scalars['Float']['output']>;
  hours?: Maybe<Scalars['ShortString']['output']>;
  icons?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Maybe<Image>>>;
  isNew?: Maybe<Scalars['Boolean']['output']>;
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  isPromo?: Maybe<Scalars['Boolean']['output']>;
  keyInfo?: Maybe<KeyInfo>;
  /** By what time to leave */
  leaveTime?: Maybe<Scalars['ShortString']['output']>;
  livingFloors?: Maybe<Scalars['Int']['output']>;
  livingSurface?: Maybe<Scalars['Int']['output']>;
  localTax?: Maybe<Scalars['Boolean']['output']>;
  mainImage?: Maybe<Image>;
  margin?: Maybe<Scalars['Float']['output']>;
  memos?: Maybe<Array<Maybe<Memo>>>;
  metaDescriptionI18n?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['ShortString']['output']>;
  note?: Maybe<Scalars['JSON']['output']>;
  onlinePayment?: Maybe<Scalars['Boolean']['output']>;
  owner?: Maybe<Owner>;
  payThere?: Maybe<Scalars['Boolean']['output']>;
  petsAllowed?: Maybe<Scalars['Boolean']['output']>;
  placeName?: Maybe<Scalars['ShortString']['output']>;
  prices?: Maybe<Array<Maybe<HousePrice>>>;
  promotions?: Maybe<Array<Maybe<PromotionRule>>>;
  rating?: Maybe<Scalars['Float']['output']>;
  regionId?: Maybe<Scalars['ID']['output']>;
  reviews?: Maybe<Array<Maybe<Review>>>;
  rooms?: Maybe<Array<Maybe<Room>>>;
  routeI18n?: Maybe<Scalars['JSON']['output']>;
  sloganI18n?: Maybe<Scalars['JSON']['output']>;
  slug?: Maybe<Scalars['ID']['output']>;
  specials?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  switchDay?: Maybe<Scalars['Int']['output']>;
  taxCategory?: Maybe<Scalars['Int']['output']>;
  taxPlatform?: Maybe<TaxPlatform>;
  taxPlatformId?: Maybe<Scalars['Int']['output']>;
  taxRegistration?: Maybe<Scalars['String']['output']>;
  tipsI18n?: Maybe<Scalars['JSON']['output']>;
  totalFloors?: Maybe<Scalars['Int']['output']>;
  totalSurface?: Maybe<Scalars['Int']['output']>;
  type: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['Timestamp']['output']>;
  voucherAttachmentsI18n?: Maybe<Scalars['JSON']['output']>;
};


/** A rental property */
export type RentalDateRangesArgs = {
  beginDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<DateRangeType>;
};

/** A rental property */
export type RentalInput = {
  /** From what time available */
  accessTime?: InputMaybe<Scalars['ShortString']['input']>;
  address?: InputMaybe<AddressInput>;
  agentChanges?: InputMaybe<Scalars['JSON']['input']>;
  agentId?: InputMaybe<Scalars['ID']['input']>;
  agentRef?: InputMaybe<Scalars['String']['input']>;
  /** Allowed capacity by owner */
  capacity?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['Float']['input']>;
  descrNote?: InputMaybe<Scalars['String']['input']>;
  descriptionI18n?: InputMaybe<I18nStringInput>;
  distances?: InputMaybe<Array<InputMaybe<DistanceInput>>>;
  domainId?: InputMaybe<Scalars['ID']['input']>;
  equipment?: InputMaybe<Array<InputMaybe<EquipmentInput>>>;
  extras?: InputMaybe<Array<InputMaybe<OptionInput>>>;
  features?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  guarantee?: InputMaybe<Scalars['Float']['input']>;
  hours?: InputMaybe<Scalars['ShortString']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  images?: InputMaybe<Array<InputMaybe<ImageInput>>>;
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  isPromo?: InputMaybe<Scalars['Boolean']['input']>;
  keyInfo?: InputMaybe<KeyInfoInput>;
  /** By what time to leave */
  leaveTime?: InputMaybe<Scalars['ShortString']['input']>;
  livingFloors?: InputMaybe<Scalars['Int']['input']>;
  livingSurface?: InputMaybe<Scalars['Int']['input']>;
  localTax?: InputMaybe<Scalars['Boolean']['input']>;
  margin?: InputMaybe<Scalars['Float']['input']>;
  memos?: InputMaybe<Array<InputMaybe<MemoInput>>>;
  metaDescriptionI18n?: InputMaybe<I18nStringInput>;
  name?: InputMaybe<Scalars['ShortString']['input']>;
  note?: InputMaybe<Scalars['JSON']['input']>;
  onlinePayment?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<OwnerInput>;
  payThere?: InputMaybe<Scalars['Boolean']['input']>;
  petsAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  placeName?: InputMaybe<Scalars['ShortString']['input']>;
  prices?: InputMaybe<Array<InputMaybe<HousePriceInput>>>;
  promotions?: InputMaybe<Array<InputMaybe<PromotionRuleInput>>>;
  rating?: InputMaybe<Scalars['Float']['input']>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
  reviews?: InputMaybe<Array<InputMaybe<ReviewInput>>>;
  rooms?: InputMaybe<Array<InputMaybe<RoomInput>>>;
  routeI18n?: InputMaybe<I18nStringInput>;
  sloganI18n?: InputMaybe<I18nStringInput>;
  slug?: InputMaybe<Scalars['ID']['input']>;
  specials?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  switchDay?: InputMaybe<Scalars['Int']['input']>;
  taxCategory?: InputMaybe<Scalars['Int']['input']>;
  taxPlatformId?: InputMaybe<Scalars['Int']['input']>;
  taxRegistration?: InputMaybe<Scalars['String']['input']>;
  tipsI18n?: InputMaybe<I18nStringInput>;
  totalFloors?: InputMaybe<Scalars['Int']['input']>;
  totalSurface?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['ID']['input']>;
  voucherAttachmentsI18n?: InputMaybe<I18nListInput>;
};

export type RentalList = {
  __typename?: 'RentalList';
  cursor?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<Rental>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Review = {
  __typename?: 'Review';
  countryId?: Maybe<Scalars['ShortString']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['ShortString']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  text?: Maybe<Scalars['JSON']['output']>;
  textI18n?: Maybe<Scalars['JSON']['output']>;
};


export type ReviewTextArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReviewInput = {
  countryId?: InputMaybe<Scalars['ShortString']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['ShortString']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  textI18n?: InputMaybe<I18nStringInput>;
};

/** A room in the property */
export type Room = {
  __typename?: 'Room';
  building?: Maybe<Scalars['ShortString']['output']>;
  equipment?: Maybe<Array<Maybe<Equipment>>>;
  floor?: Maybe<Scalars['ShortString']['output']>;
  room?: Maybe<Scalars['ID']['output']>;
};

/** A room in the property */
export type RoomInput = {
  building?: InputMaybe<Scalars['ShortString']['input']>;
  equipment?: InputMaybe<Array<InputMaybe<EquipmentInput>>>;
  floor?: InputMaybe<Scalars['ShortString']['input']>;
  room?: InputMaybe<Scalars['ID']['input']>;
};

export type Saldo = {
  __typename?: 'Saldo';
  agentId?: Maybe<Scalars['ID']['output']>;
  agentName?: Maybe<Scalars['ShortString']['output']>;
  agentSaldoSum?: Maybe<Scalars['Float']['output']>;
  agentSaldoSumToPay?: Maybe<Scalars['Float']['output']>;
  agentTotalFutureSumToPay?: Maybe<Scalars['Float']['output']>;
  buyRentalSum?: Maybe<Scalars['Float']['output']>;
  buyTotalSum?: Maybe<Scalars['Float']['output']>;
  capSaldoSum?: Maybe<Scalars['Float']['output']>;
  creditTs?: Maybe<Scalars['Timestamp']['output']>;
  insuranceToPaySum?: Maybe<Scalars['Float']['output']>;
  lastPaymentDate?: Maybe<Scalars['Timestamp']['output']>;
  optionsTotalSum?: Maybe<Scalars['Float']['output']>;
  paidSum?: Maybe<Scalars['Float']['output']>;
  received?: Maybe<Scalars['Float']['output']>;
  receivedGuarantee?: Maybe<Scalars['Float']['output']>;
  sellRentalSum?: Maybe<Scalars['Float']['output']>;
  sellTotalSum?: Maybe<Scalars['Float']['output']>;
  withoutGuarantee?: Maybe<Scalars['Float']['output']>;
};

export enum Section {
  App = 'APP',
  Buildings = 'BUILDINGS',
  Contactreason = 'CONTACTREASON',
  Contractstatus = 'CONTRACTSTATUS',
  Country = 'COUNTRY',
  Email = 'EMAIL',
  Equipment = 'EQUIPMENT',
  Extra = 'EXTRA',
  Feature = 'FEATURE',
  Featuregroup = 'FEATUREGROUP',
  Floors = 'FLOORS',
  Housingtype = 'HOUSINGTYPE',
  Howfound = 'HOWFOUND',
  Imagetag = 'IMAGETAG',
  Places = 'PLACES',
  Region = 'REGION',
  Rentyourhousetype = 'RENTYOURHOUSETYPE',
  Spaces = 'SPACES',
  Specials = 'SPECIALS',
  Tax = 'TAX'
}

export type Special = {
  __typename?: 'Special';
  icon?: Maybe<Scalars['ShortString']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  showOnHomepage?: Maybe<Scalars['Boolean']['output']>;
  thumbnail?: Maybe<Image>;
  title?: Maybe<Scalars['ShortString']['output']>;
  titleI18n?: Maybe<Scalars['JSON']['output']>;
};


export type SpecialTitleArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SpecialList = {
  __typename?: 'SpecialList';
  cursor?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<Special>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Suggestion = {
  __typename?: 'Suggestion';
  desc?: Maybe<Scalars['JSON']['output']>;
  descI18n?: Maybe<Scalars['JSON']['output']>;
  imageId?: Maybe<Scalars['ID']['output']>;
  link?: Maybe<Scalars['JSON']['output']>;
  linkI18n?: Maybe<Scalars['JSON']['output']>;
  title?: Maybe<Scalars['JSON']['output']>;
  titleI18n?: Maybe<Scalars['JSON']['output']>;
};


export type SuggestionDescArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SuggestionLinkArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SuggestionTitleArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TaxPlatform = {
  __typename?: 'TaxPlatform';
  bank?: Maybe<Bank>;
  comms?: Maybe<Array<Maybe<CommType>>>;
  id: Scalars['Int']['output'];
  name: Scalars['ShortString']['output'];
  taxes?: Maybe<Array<Maybe<TouristTax>>>;
  url?: Maybe<Scalars['URL']['output']>;
};

export type TaxPlatformInput = {
  bank?: InputMaybe<BankInput>;
  comms?: InputMaybe<Array<InputMaybe<CommTypeInput>>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['ShortString']['input']>;
  taxes?: InputMaybe<Array<InputMaybe<TouristTaxInput>>>;
  url?: InputMaybe<Scalars['URL']['input']>;
};

export type Template = {
  __typename?: 'Template';
  description?: Maybe<Scalars['ShortString']['output']>;
  id: Scalars['ID']['output'];
  meta?: Maybe<Meta>;
  sections?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  tag?: Maybe<Scalars['ID']['output']>;
};

export type TemplateInput = {
  description?: InputMaybe<Scalars['ShortString']['input']>;
  id: Scalars['ID']['input'];
  sections?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  tag?: InputMaybe<Scalars['ID']['input']>;
};

export type TemplateList = {
  __typename?: 'TemplateList';
  cursor?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<Template>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum Title {
  Family = 'FAMILY',
  Miss = 'MISS',
  Mister = 'MISTER',
  Mistress = 'MISTRESS',
  Other = 'OTHER'
}

export type TouristTax = {
  __typename?: 'TouristTax';
  additionalRate: Scalars['Float']['output'];
  byCategory: Array<Maybe<Scalars['Float']['output']>>;
  maxTax: Scalars['Float']['output'];
  startDate: Scalars['Date']['output'];
};

export type TouristTaxInput = {
  additionalRate: Scalars['Float']['input'];
  byCategory: Array<InputMaybe<Scalars['Float']['input']>>;
  maxTax: Scalars['Float']['input'];
  startDate: Scalars['Date']['input'];
};

export type Translation = {
  __typename?: 'Translation';
  featureGroup?: Maybe<Scalars['String']['output']>;
  html?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  meta?: Maybe<Scalars['JSON']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  section?: Maybe<Section>;
  text?: Maybe<Scalars['JSON']['output']>;
  textI18n?: Maybe<Scalars['JSON']['output']>;
};


export type TranslationTextArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TranslationInput = {
  html?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['ShortString']['input']>;
  meta?: InputMaybe<Scalars['JSON']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  section?: InputMaybe<Section>;
  textI18n: I18nStringInput;
};

export type Upload = {
  __typename?: 'Upload';
  /** Original filename */
  filename?: Maybe<Scalars['ShortString']['output']>;
  id: Scalars['ID']['output'];
  /** Free-form data */
  meta?: Maybe<Scalars['JSON']['output']>;
  /** MIME type */
  mime?: Maybe<Scalars['String']['output']>;
  /** Location on server */
  path?: Maybe<Scalars['ShortString']['output']>;
  /** File size */
  size?: Maybe<Scalars['Int']['output']>;
  /** Upload timestamp */
  ts?: Maybe<Scalars['Timestamp']['output']>;
};

export type UploadInput = {
  /** Original filename */
  filename?: InputMaybe<Scalars['ShortString']['input']>;
  id: Scalars['ID']['input'];
  meta?: InputMaybe<Scalars['JSON']['input']>;
};

export type UploadMetadataInput = {
  id: Scalars['ID']['input'];
  meta?: InputMaybe<Scalars['JSON']['input']>;
};

export type User = {
  __typename?: 'User';
  /** We allow user to manage many agents */
  agentIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  createTs?: Maybe<Scalars['ShortString']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['Email']['output']>;
  firstName?: Maybe<Scalars['ShortString']['output']>;
  fullName?: Maybe<Scalars['ShortString']['output']>;
  id: Scalars['ID']['output'];
  lang?: Maybe<Scalars['ShortString']['output']>;
  lastName?: Maybe<Scalars['ShortString']['output']>;
  loginTs?: Maybe<Scalars['ShortString']['output']>;
  role?: Maybe<UserRoles>;
};

export type UserInput = {
  agentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['Email']['input'];
  firstName?: InputMaybe<Scalars['ShortString']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lang?: InputMaybe<Scalars['ShortString']['input']>;
  lastName?: InputMaybe<Scalars['ShortString']['input']>;
  loginTs?: InputMaybe<Scalars['ShortString']['input']>;
  password?: InputMaybe<Scalars['ShortString']['input']>;
  role?: InputMaybe<UserRoles>;
};

export type UserList = {
  __typename?: 'UserList';
  cursor?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<User>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum UserRoles {
  Admin = 'ADMIN',
  Agent = 'AGENT'
}

export enum DateRangeType {
  Block = 'BLOCK',
  Contract = 'CONTRACT',
  Free = 'FREE',
  Price = 'PRICE'
}

export type Mutation = {
  __typename?: 'mutation';
  acceptHouseChanges?: Maybe<Rental>;
  addPayment?: Maybe<Payment>;
  cancelContract?: Maybe<Contract>;
  changePassword?: Maybe<User>;
  closeContract?: Maybe<Contract>;
  confirmContract?: Maybe<Contract>;
  deleteUser?: Maybe<Scalars['Boolean']['output']>;
  editPayment?: Maybe<Payment>;
  geocode?: Maybe<Scalars['Boolean']['output']>;
  /** get a Stripe token for paying a contract */
  getStripeToken: Scalars['String']['output'];
  googleLogin?: Maybe<Scalars['Boolean']['output']>;
  login?: Maybe<Scalars['Boolean']['output']>;
  logout?: Maybe<Scalars['Boolean']['output']>;
  passwordReset?: Maybe<Scalars['Boolean']['output']>;
  recalcHouses?: Maybe<Scalars['Boolean']['output']>;
  registerClient?: Maybe<Client>;
  registerContract?: Maybe<Contract>;
  registerUser?: Maybe<Scalars['Boolean']['output']>;
  rejectHouseChanges?: Maybe<Rental>;
  removeAgent?: Maybe<Scalars['Boolean']['output']>;
  removeAgentOption?: Maybe<Agent>;
  removeBlockedRange?: Maybe<Scalars['Boolean']['output']>;
  removeBlogPost?: Maybe<Scalars['Boolean']['output']>;
  removeClient?: Maybe<Scalars['Boolean']['output']>;
  removeHouse?: Maybe<Scalars['Boolean']['output']>;
  removeHouseDomain?: Maybe<Scalars['Boolean']['output']>;
  removeRedirection?: Maybe<Scalars['Boolean']['output']>;
  removeTemplate?: Maybe<Scalars['Boolean']['output']>;
  removeTranslation?: Maybe<Scalars['Boolean']['output']>;
  removeUpload?: Maybe<Scalars['Boolean']['output']>;
  saveAgent?: Maybe<Agent>;
  saveAgentOption?: Maybe<Agent>;
  saveBlockedRange?: Maybe<Scalars['Boolean']['output']>;
  saveBlogPost?: Maybe<BlogPost>;
  saveBlogPostTemplate?: Maybe<Scalars['Boolean']['output']>;
  saveClient?: Maybe<Client>;
  saveContent?: Maybe<Content>;
  saveContract?: Maybe<Contract>;
  saveHouse?: Maybe<Rental>;
  saveHouseDomain?: Maybe<HouseDomain>;
  saveInstagramCreds?: Maybe<InstagramCreds>;
  saveLandingPage?: Maybe<LandingPage>;
  saveRedirection?: Maybe<Redirection>;
  saveSpecial?: Maybe<Special>;
  saveTaxPlatform?: Maybe<TaxPlatform>;
  saveTemplate?: Maybe<Template>;
  saveTranslation?: Maybe<Translation>;
  saveUploadMetadata?: Maybe<Upload>;
  saveUser?: Maybe<User>;
  sendConfirmation?: Maybe<Scalars['Boolean']['output']>;
  sendContact?: Maybe<Scalars['Boolean']['output']>;
  sendContractConfirmation?: Maybe<Contract>;
  sendEmail?: Maybe<Scalars['Boolean']['output']>;
  sendEmailAgain?: Maybe<Scalars['Boolean']['output']>;
  sendEmailWithMandrill?: Maybe<Scalars['Boolean']['output']>;
  sendError?: Maybe<Scalars['Boolean']['output']>;
  sendVoucher?: Maybe<Contract>;
  sendYearlyReport?: Maybe<Agent>;
  /**
   * Set debug level. If you pass one of the special strings ("debug", "verbose") they will expand. Otherwise what you give is passed to debug().
   * 	The return value is the string as parsed by debug.
   * 	Pass "-*" to disable debugging.
   */
  setDebug?: Maybe<Scalars['String']['output']>;
  subscribeToNewsletter?: Maybe<Scalars['Boolean']['output']>;
  updateUpload?: Maybe<Upload>;
};


export type MutationAcceptHouseChangesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAddPaymentArgs = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  expireTs?: InputMaybe<Scalars['Date']['input']>;
  isGuarantee?: InputMaybe<Scalars['Boolean']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelContractArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChangePasswordArgs = {
  email: Scalars['Email']['input'];
  password: Scalars['ShortString']['input'];
};


export type MutationCloseContractArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConfirmContractArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEditPaymentArgs = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  expireTs?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isGuarantee?: InputMaybe<Scalars['Boolean']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGetStripeTokenArgs = {
  amount: Scalars['Float']['input'];
  contractId: Scalars['ID']['input'];
  isGuarantee?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationGoogleLoginArgs = {
  token: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  email: Scalars['Email']['input'];
  password: Scalars['ShortString']['input'];
};


export type MutationPasswordResetArgs = {
  email: Scalars['Email']['input'];
};


export type MutationRegisterClientArgs = {
  client: ClientInput;
};


export type MutationRegisterContractArgs = {
  contract: RegisterInput;
};


export type MutationRegisterUserArgs = {
  newUser: UserInput;
};


export type MutationRejectHouseChangesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveAgentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveAgentOptionArgs = {
  agentId: Scalars['ID']['input'];
  optionId: Scalars['ID']['input'];
};


export type MutationRemoveBlockedRangeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveBlogPostArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveClientArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveHouseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveHouseDomainArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveRedirectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveTranslationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveUploadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSaveAgentArgs = {
  agent: AgentInput;
};


export type MutationSaveAgentOptionArgs = {
  agentId: Scalars['ID']['input'];
  option?: InputMaybe<OptionInput>;
};


export type MutationSaveBlockedRangeArgs = {
  blockedRange?: InputMaybe<BlockedRangeInput>;
};


export type MutationSaveBlogPostArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  images?: InputMaybe<Array<InputMaybe<ImageInput>>>;
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  mainImage?: InputMaybe<ImageInput>;
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['ShortString']['input']>>>;
  summaryI18n: I18nStringInput;
  template?: InputMaybe<Scalars['JSON']['input']>;
  titleI18n: I18nStringInput;
};


export type MutationSaveBlogPostTemplateArgs = {
  id: Scalars['ID']['input'];
  template: Scalars['JSON']['input'];
};


export type MutationSaveClientArgs = {
  client: ClientInput;
};


export type MutationSaveContentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  textI18n: I18nStringInput;
  titleI18n: I18nStringInput;
};


export type MutationSaveContractArgs = {
  contract: ContractInput;
};


export type MutationSaveHouseArgs = {
  house: RentalInput;
};


export type MutationSaveHouseDomainArgs = {
  houseDomain: HouseDomainInput;
};


export type MutationSaveInstagramCredsArgs = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSaveLandingPageArgs = {
  landingPage: LandingPageInput;
};


export type MutationSaveRedirectionArgs = {
  redirection: RedirectionInput;
};


export type MutationSaveSpecialArgs = {
  icon?: InputMaybe<Scalars['ShortString']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<ImageInput>;
  showOnHomepage?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail?: InputMaybe<ImageInput>;
  titleI18n: I18nStringInput;
};


export type MutationSaveTaxPlatformArgs = {
  taxPlatform: TaxPlatformInput;
};


export type MutationSaveTemplateArgs = {
  template: TemplateInput;
};


export type MutationSaveTranslationArgs = {
  translation: TranslationInput;
};


export type MutationSaveUploadMetadataArgs = {
  upload: UploadMetadataInput;
};


export type MutationSaveUserArgs = {
  user: UserInput;
};


export type MutationSendConfirmationArgs = {
  content?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationSendContactArgs = {
  content?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationSendContractConfirmationArgs = {
  id: Scalars['ID']['input'];
  messageForAgent?: InputMaybe<Scalars['JSON']['input']>;
  messageForClient?: InputMaybe<Scalars['JSON']['input']>;
  sendToAgent?: InputMaybe<Scalars['Boolean']['input']>;
  sendToClient?: InputMaybe<Scalars['Boolean']['input']>;
  subjectForAgent?: InputMaybe<Scalars['String']['input']>;
  subjectForClient?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendEmailArgs = {
  data?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationSendEmailAgainArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSendEmailWithMandrillArgs = {
  email?: InputMaybe<EmailInput>;
};


export type MutationSendErrorArgs = {
  error: Scalars['String']['input'];
  info?: InputMaybe<Scalars['String']['input']>;
  ssr?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendVoucherArgs = {
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['JSON']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendYearlyReportArgs = {
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['JSON']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  year: Scalars['ShortString']['input'];
};


export type MutationSetDebugArgs = {
  DEBUG?: InputMaybe<Scalars['ShortString']['input']>;
};


export type MutationSubscribeToNewsletterArgs = {
  subscriber?: InputMaybe<NewsletterInput>;
};


export type MutationUpdateUploadArgs = {
  upload: UploadInput;
};

export type Query = {
  __typename?: 'query';
  agent?: Maybe<Agent>;
  agentChangesCount?: Maybe<Scalars['Int']['output']>;
  agentSaldo?: Maybe<Scalars['Float']['output']>;
  agentSaldos?: Maybe<Array<Maybe<Saldo>>>;
  agents?: Maybe<AgentList>;
  agentsCount?: Maybe<Scalars['Int']['output']>;
  allTemplates?: Maybe<Scalars['JSON']['output']>;
  allTranslations?: Maybe<Scalars['JSON']['output']>;
  blogPost?: Maybe<BlogPost>;
  blogPosts?: Maybe<BlogPostList>;
  client?: Maybe<Client>;
  clients?: Maybe<ClientList>;
  clientsCount?: Maybe<Scalars['Int']['output']>;
  content?: Maybe<Content>;
  contract?: Maybe<Contract>;
  contracts?: Maybe<ContractList>;
  contractsSummary?: Maybe<Scalars['JSON']['output']>;
  contractsYears?: Maybe<Array<Maybe<Scalars['ShortString']['output']>>>;
  emailPreview?: Maybe<Scalars['String']['output']>;
  emailVars?: Maybe<Scalars['JSON']['output']>;
  /** equipment used in each room type, sorted by frequency */
  equipmentByRoom?: Maybe<Scalars['JSON']['output']>;
  errors?: Maybe<JsonList>;
  externalSellerOptions?: Maybe<Array<Maybe<Scalars['ShortString']['output']>>>;
  featuredHouses?: Maybe<Array<Maybe<House>>>;
  features?: Maybe<Array<Maybe<Translation>>>;
  fullHouse?: Maybe<Rental>;
  fullHouses?: Maybe<RentalList>;
  hasHistory?: Maybe<Scalars['Boolean']['output']>;
  historyFor?: Maybe<JsonList>;
  house?: Maybe<House>;
  houseDomain?: Maybe<HouseDomain>;
  houseDomains?: Maybe<HouseDomainList>;
  houseTypes?: Maybe<Scalars['JSON']['output']>;
  houses?: Maybe<HouseList>;
  housesCount?: Maybe<Scalars['Int']['output']>;
  housesFilterCount?: Maybe<HouseFilterCounters>;
  housesMap?: Maybe<Scalars['JSON']['output']>;
  instagramCreds?: Maybe<InstagramCreds>;
  instagramFeed?: Maybe<Array<Maybe<InstagramPost>>>;
  landingPage?: Maybe<LandingPage>;
  landingPageByUrl?: Maybe<LandingPage>;
  landingPagesAdmin?: Maybe<LandingPageList>;
  newOrPromo?: Maybe<Array<Maybe<House>>>;
  outboxEmails?: Maybe<OutboxEmailList>;
  paymentInfo?: Maybe<PaymentInfo>;
  payments?: Maybe<PaymentList>;
  paymentsYears?: Maybe<Array<Maybe<Scalars['ShortString']['output']>>>;
  redirection?: Maybe<Redirection>;
  redirections?: Maybe<RedirectionList>;
  region?: Maybe<Region>;
  regionCountryMap?: Maybe<Scalars['JSON']['output']>;
  regions?: Maybe<Array<Maybe<Region>>>;
  searchOptions?: Maybe<Scalars['JSON']['output']>;
  special?: Maybe<Special>;
  specials?: Maybe<SpecialList>;
  ssrFails?: Maybe<Scalars['Int']['output']>;
  taxPlatform?: Maybe<TaxPlatform>;
  taxPlatforms?: Maybe<Array<Maybe<TaxPlatform>>>;
  template?: Maybe<Template>;
  templates?: Maybe<TemplateList>;
  touristTaxSum?: Maybe<Scalars['Float']['output']>;
  translation?: Maybe<Translation>;
  translations?: Maybe<Array<Maybe<Translation>>>;
  upload?: Maybe<Upload>;
  user?: Maybe<User>;
  users?: Maybe<UserList>;
};


export type QueryAgentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAgentSaldoArgs = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAgentSaldosArgs = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<Scalars['ShortString']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
  year?: InputMaybe<Scalars['ShortString']['input']>;
};


export type QueryAgentsArgs = {
  creditTsSet?: InputMaybe<Scalars['Boolean']['input']>;
  cursor?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<Scalars['ShortString']['input']>;
  hasHousesOnline?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['ShortString']['input']>;
  saldoMin?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
  text?: InputMaybe<Scalars['ShortString']['input']>;
};


export type QueryAgentsCountArgs = {
  filter?: InputMaybe<Scalars['ShortString']['input']>;
};


export type QueryAllTranslationsArgs = {
  lang?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Section>;
};


export type QueryBlogPostArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  titleSlug?: InputMaybe<Scalars['ShortString']['input']>;
};


export type QueryBlogPostsArgs = {
  cursor?: InputMaybe<Scalars['ShortString']['input']>;
  evenEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyOnline?: InputMaybe<Scalars['Boolean']['input']>;
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['ShortString']['input']>>>;
};


export type QueryClientArgs = {
  email?: InputMaybe<Scalars['Email']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryClientsArgs = {
  creditTsSet?: InputMaybe<Scalars['Boolean']['input']>;
  cursor?: InputMaybe<Scalars['ShortString']['input']>;
  filter?: InputMaybe<Scalars['ShortString']['input']>;
  fullName?: InputMaybe<Scalars['ShortString']['input']>;
  includeProspects?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  saldoMin?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryClientsCountArgs = {
  filter?: InputMaybe<Scalars['ShortString']['input']>;
};


export type QueryContentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContractArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContractsArgs = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
  capId?: InputMaybe<Scalars['ShortString']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  createdThroughWebsite?: InputMaybe<Scalars['Boolean']['input']>;
  cursor?: InputMaybe<Scalars['ID']['input']>;
  hasAction?: InputMaybe<Scalars['Boolean']['input']>;
  hasInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  hasOptions?: InputMaybe<Scalars['Boolean']['input']>;
  hasTouristTax?: InputMaybe<Scalars['Boolean']['input']>;
  houseId?: InputMaybe<Scalars['ID']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  isExternalSeller?: InputMaybe<Scalars['Boolean']['input']>;
  isFinished?: InputMaybe<Scalars['Boolean']['input']>;
  isOneWeek?: InputMaybe<Scalars['Boolean']['input']>;
  isOverdue?: InputMaybe<Scalars['Boolean']['input']>;
  isSoon?: InputMaybe<Scalars['Boolean']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  needsGuaranteeReturn?: InputMaybe<Scalars['Boolean']['input']>;
  needsGuaranteeToBePaid?: InputMaybe<Scalars['Boolean']['input']>;
  needsVoucher?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<ContractStatus>;
  statuses?: InputMaybe<Array<InputMaybe<ContractStatus>>>;
  year?: InputMaybe<Scalars['ShortString']['input']>;
};


export type QueryContractsSummaryArgs = {
  year?: InputMaybe<Scalars['ShortString']['input']>;
};


export type QueryContractsYearsArgs = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  houseId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEmailPreviewArgs = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<Scalars['JSON']['input']>;
  type: Scalars['String']['input'];
  year?: InputMaybe<Scalars['ShortString']['input']>;
};


export type QueryEmailVarsArgs = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryErrorsArgs = {
  cursor?: InputMaybe<Scalars['ShortString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFeaturedHousesArgs = {
  beginDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  newOrPromo?: InputMaybe<Scalars['Boolean']['input']>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFeaturesArgs = {
  lang?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFullHouseArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFullHousesArgs = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
  beginDate?: InputMaybe<Scalars['Date']['input']>;
  cursor?: InputMaybe<Scalars['ShortString']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  featuresAllIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  hasAgentChanges?: InputMaybe<Scalars['Boolean']['input']>;
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['ShortString']['input']>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['ShortString']['input']>;
  type?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryHasHistoryArgs = {
  id: Scalars['ID']['input'];
  modelName: Scalars['ShortString']['input'];
};


export type QueryHistoryForArgs = {
  cursor?: InputMaybe<Scalars['ShortString']['input']>;
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  modelName: Scalars['ShortString']['input'];
};


export type QueryHouseArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryHouseDomainArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHouseDomainsArgs = {
  cursor?: InputMaybe<Scalars['ShortString']['input']>;
  filter?: InputMaybe<Scalars['ShortString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryHousesArgs = {
  beginDate?: InputMaybe<Scalars['Date']['input']>;
  cursor?: InputMaybe<Scalars['ShortString']['input']>;
  domainId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  featuresAllIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  houseIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isFree?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  isPromo?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['ShortString']['input']>;
  priceBelow?: InputMaybe<Scalars['Int']['input']>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
  specialId?: InputMaybe<Scalars['ID']['input']>;
  specialsAllIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type?: InputMaybe<Scalars['ID']['input']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryHousesCountArgs = {
  beginDate?: InputMaybe<Scalars['Date']['input']>;
  cursor?: InputMaybe<Scalars['ShortString']['input']>;
  domainId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  featuresAllIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  houseIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isFree?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  isPromo?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['ShortString']['input']>;
  priceBelow?: InputMaybe<Scalars['Int']['input']>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
  specialId?: InputMaybe<Scalars['ID']['input']>;
  specialsAllIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type?: InputMaybe<Scalars['ID']['input']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryHousesFilterCountArgs = {
  beginDate?: InputMaybe<Scalars['Date']['input']>;
  cursor?: InputMaybe<Scalars['ShortString']['input']>;
  domainId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  featuresAllIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  houseIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  idNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isFree?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  isPromo?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['ShortString']['input']>;
  priceBelow?: InputMaybe<Scalars['Int']['input']>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
  specialId?: InputMaybe<Scalars['ID']['input']>;
  specialsAllIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type?: InputMaybe<Scalars['ID']['input']>;
  typeIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryHousesMapArgs = {
  isFree?: InputMaybe<Scalars['Boolean']['input']>;
  isPromo?: InputMaybe<Scalars['Boolean']['input']>;
  specialId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLandingPageArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLandingPageByUrlArgs = {
  followRedirects?: InputMaybe<Scalars['Boolean']['input']>;
  lang: Scalars['ShortString']['input'];
  url: Scalars['ShortString']['input'];
};


export type QueryLandingPagesAdminArgs = {
  cursor?: InputMaybe<Scalars['ShortString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyOnline?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNewOrPromoArgs = {
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  isPromo?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  regionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOutboxEmailsArgs = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  cursor?: InputMaybe<Scalars['ShortString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryPaymentInfoArgs = {
  contractId: Scalars['ID']['input'];
};


export type QueryPaymentsArgs = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  contractIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  cursor?: InputMaybe<Scalars['ShortString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['ShortString']['input']>;
};


export type QueryPaymentsYearsArgs = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRedirectionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRedirectionsArgs = {
  cursor?: InputMaybe<Scalars['ShortString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRegionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRegionsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QuerySpecialArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySpecialsArgs = {
  cursor?: InputMaybe<Scalars['ShortString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  showOnHomepage?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['ShortString']['input']>;
};


export type QuerySsrFailsArgs = {
  minutes?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTaxPlatformArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTemplateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTemplatesArgs = {
  cursor?: InputMaybe<Scalars['ShortString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tag?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTouristTaxSumArgs = {
  year?: InputMaybe<Scalars['ShortString']['input']>;
};


export type QueryTranslationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['ShortString']['input']>;
  section?: InputMaybe<Section>;
};


export type QueryTranslationsArgs = {
  lang?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Section>;
};


export type QueryUploadArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUserArgs = {
  email?: InputMaybe<Scalars['Email']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersArgs = {
  cursor?: InputMaybe<Scalars['ShortString']['input']>;
  email?: InputMaybe<Scalars['Email']['input']>;
  filter?: InputMaybe<Scalars['ShortString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};

export type BlogPostQueryQueryVariables = Exact<{
  titleSlug: Scalars['ShortString']['input'];
}>;


export type BlogPostQueryQuery = { __typename?: 'query', blogPost?: { __typename?: 'BlogPost', id: string, titleI18n?: any | null, title?: string | null, text?: any | null, summary?: string | null, isOnline?: boolean | null, regionIds?: Array<string | null> | null, template?: any | null, mainImage?: { __typename?: 'Image', w?: number | null, h?: number | null, blurhash?: string | null, upload?: { __typename?: 'Upload', id: string } | null } | null } | null };

export type FullBlogPostQueryQueryVariables = Exact<{
  postId: Scalars['ID']['input'];
  isEditing: Scalars['Boolean']['input'];
}>;


export type FullBlogPostQueryQuery = { __typename?: 'query', blogPost?: { __typename?: 'BlogPost', id: string, date?: any | null, title?: string | null, titleI18n?: any | null, text?: any | null, summaryI18n?: any | null, summary?: string | null, isOnline?: boolean | null, regionIds?: Array<string | null> | null, template?: any | null, images?: Array<{ __typename?: 'Image', w?: number | null, h?: number | null, blurhash?: string | null, show?: boolean | null, upload?: { __typename?: 'Upload', id: string } | null } | null> | null, mainImage?: { __typename?: 'Image', w?: number | null, h?: number | null, blurhash?: string | null, upload?: { __typename?: 'Upload', id: string } | null } | null } | null };

export type BlogPostsListQueryQueryVariables = Exact<{
  onlyOnline: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  evenEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['ShortString']['input']>> | InputMaybe<Scalars['ShortString']['input']>>;
}>;


export type BlogPostsListQueryQuery = { __typename?: 'query', blogPosts?: { __typename?: 'BlogPostList', items?: Array<{ __typename?: 'BlogPost', id: string, date?: any | null, title?: string | null, isOnline?: boolean | null } | null> | null } | null };

export type BlogPostsQueryQueryVariables = Exact<{
  onlyOnline: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  evenEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['ShortString']['input']>> | InputMaybe<Scalars['ShortString']['input']>>;
}>;


export type BlogPostsQueryQuery = { __typename?: 'query', blogPosts?: { __typename?: 'BlogPostList', total?: number | null, items?: Array<{ __typename?: 'BlogPost', id: string, date?: any | null, title?: string | null, titleI18n?: any | null, text?: any | null, isOnline?: boolean | null, template?: any | null, mainImage?: { __typename?: 'Image', w?: number | null, h?: number | null, blurhash?: string | null, upload?: { __typename?: 'Upload', id: string } | null } | null } | null> | null } | null };

export type SaveBlogPostMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  date: Scalars['Date']['input'];
  titleI18n: I18nStringInput;
  summaryI18n: I18nStringInput;
  isOnline: Scalars['Boolean']['input'];
  images?: InputMaybe<Array<InputMaybe<ImageInput>> | InputMaybe<ImageInput>>;
  mainImage?: InputMaybe<ImageInput>;
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['ShortString']['input']>> | InputMaybe<Scalars['ShortString']['input']>>;
  template?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type SaveBlogPostMutation = { __typename?: 'mutation', saveBlogPost?: { __typename?: 'BlogPost', id: string, date?: any | null, title?: string | null, titleI18n?: any | null, text?: any | null, summary?: string | null, isOnline?: boolean | null, regionIds?: Array<string | null> | null, images?: Array<{ __typename?: 'Image', w?: number | null, h?: number | null, blurhash?: string | null, upload?: { __typename?: 'Upload', id: string } | null } | null> | null, mainImage?: { __typename?: 'Image', w?: number | null, h?: number | null, blurhash?: string | null, upload?: { __typename?: 'Upload', id: string } | null } | null } | null };

export type RemoveBlogPostMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveBlogPostMutation = { __typename?: 'mutation', removeBlogPost?: boolean | null };

export type SaveBlogPostTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  template: Scalars['JSON']['input'];
}>;


export type SaveBlogPostTemplateMutation = { __typename?: 'mutation', saveBlogPostTemplate?: boolean | null };

export type SaveBlockedRangeMutationVariables = Exact<{
  blockedRange: BlockedRangeInput;
}>;


export type SaveBlockedRangeMutation = { __typename?: 'mutation', saveBlockedRange?: boolean | null };

export type RemoveBlockedRangeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveBlockedRangeMutation = { __typename?: 'mutation', removeBlockedRange?: boolean | null };

export type EmailPreviewQueryVariables = Exact<{
  type: Scalars['String']['input'];
  contractId?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<Scalars['JSON']['input']>;
  agentId?: InputMaybe<Scalars['ID']['input']>;
  year?: InputMaybe<Scalars['ShortString']['input']>;
}>;


export type EmailPreviewQuery = { __typename?: 'query', emailPreview?: string | null };

export type SendEmailWithMandrillMutationVariables = Exact<{
  email?: InputMaybe<EmailInput>;
}>;


export type SendEmailWithMandrillMutation = { __typename?: 'mutation', sendEmailWithMandrill?: boolean | null };

export type SendEmailAgainMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SendEmailAgainMutation = { __typename?: 'mutation', sendEmailAgain?: boolean | null };

export type CommonFieldsFragment = { __typename?: 'LandingPage', id: number, urlI18n?: any | null, url?: string | null, imageId?: string | null, houseId?: string | null, regionId?: string | null, template?: any | null, search?: { __typename?: 'LandingPageSearchType', region?: Array<string | null> | null, houseType?: string | null, size?: number | null, features?: any | null, priceRange?: string | null, specials?: any | null } | null };

export type LandingPageByUrlQueryVariables = Exact<{
  url: Scalars['ShortString']['input'];
  lang: Scalars['ShortString']['input'];
}>;


export type LandingPageByUrlQuery = { __typename?: 'query', landingPageByUrl?: { __typename?: 'LandingPage', metaDesc?: string | null, metaKeywords?: string | null, metaTitle?: string | null, redirectUrl?: any | null, id: number, urlI18n?: any | null, url?: string | null, imageId?: string | null, houseId?: string | null, regionId?: string | null, template?: any | null, search?: { __typename?: 'LandingPageSearchType', region?: Array<string | null> | null, houseType?: string | null, size?: number | null, features?: any | null, priceRange?: string | null, specials?: any | null } | null } | null };

export type LandingPageByUrlAdminQueryVariables = Exact<{
  url: Scalars['ShortString']['input'];
  lang: Scalars['ShortString']['input'];
}>;


export type LandingPageByUrlAdminQuery = { __typename?: 'query', landingPageByUrl?: { __typename?: 'LandingPage', isOnline: boolean, metaDescI18n?: any | null, metaKeywordsI18n?: any | null, metaTitleI18n?: any | null, redirectId?: string | null, redirectUrlI18n?: any | null, id: number, urlI18n?: any | null, url?: string | null, imageId?: string | null, houseId?: string | null, regionId?: string | null, template?: any | null, search?: { __typename?: 'LandingPageSearchType', region?: Array<string | null> | null, houseType?: string | null, size?: number | null, features?: any | null, priceRange?: string | null, specials?: any | null } | null } | null };

export type LandingPageAdminQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type LandingPageAdminQuery = { __typename?: 'query', landingPage?: { __typename?: 'LandingPage', isOnline: boolean, metaDescI18n?: any | null, metaKeywordsI18n?: any | null, metaTitleI18n?: any | null, redirectId?: string | null, redirectUrlI18n?: any | null, id: number, urlI18n?: any | null, url?: string | null, imageId?: string | null, houseId?: string | null, regionId?: string | null, template?: any | null, search?: { __typename?: 'LandingPageSearchType', region?: Array<string | null> | null, houseType?: string | null, size?: number | null, features?: any | null, priceRange?: string | null, specials?: any | null } | null } | null };

export type LandingPagesAdminQueryQueryVariables = Exact<{
  onlyOnline: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LandingPagesAdminQueryQuery = { __typename?: 'query', landingPagesAdmin?: { __typename?: 'LandingPageList', items?: Array<{ __typename?: 'LandingPage', isOnline: boolean, redirectId?: string | null, metaTitleI18n?: any | null, redirectUrlI18n?: any | null, id: number, urlI18n?: any | null, url?: string | null, imageId?: string | null, houseId?: string | null, regionId?: string | null, template?: any | null, search?: { __typename?: 'LandingPageSearchType', region?: Array<string | null> | null, houseType?: string | null, size?: number | null, features?: any | null, priceRange?: string | null, specials?: any | null } | null } | null> | null } | null };

export type SaveLandingPageMutationVariables = Exact<{
  landingPage: LandingPageInput;
}>;


export type SaveLandingPageMutation = { __typename?: 'mutation', saveLandingPage?: { __typename?: 'LandingPage', id: number, urlI18n?: any | null, imageId?: string | null, houseId?: string | null, template?: any | null, isOnline: boolean, metaDescI18n?: any | null, metaKeywordsI18n?: any | null, metaTitleI18n?: any | null, redirectId?: string | null, redirectUrlI18n?: any | null, search?: { __typename?: 'LandingPageSearchType', region?: Array<string | null> | null, houseType?: string | null, size?: number | null, features?: any | null, priceRange?: string | null, specials?: any | null } | null } | null };

export type SubscribeToNewsletterMutationVariables = Exact<{
  subscriber?: InputMaybe<NewsletterInput>;
}>;


export type SubscribeToNewsletterMutation = { __typename?: 'mutation', subscribeToNewsletter?: boolean | null };

export type FullHouseQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type FullHouseQuery = { __typename?: 'query', fullHouse?: { __typename?: 'Rental', id: string, name?: string | null, agentChanges?: any | null } | null };

export type UploadQueryVariables = Exact<{
  value: Scalars['ID']['input'];
}>;


export type UploadQuery = { __typename?: 'query', upload?: { __typename?: 'Upload', id: string, meta?: any | null } | null };

export type SpecialsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SpecialsQueryQuery = { __typename?: 'query', specials?: { __typename?: 'SpecialList', items?: Array<{ __typename?: 'Special', id: string, title?: string | null } | null> | null } | null };

export type AllHousesQueryVariables = Exact<{
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  featuresAllIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type AllHousesQuery = { __typename?: 'query', fullHouses?: { __typename?: 'RentalList', items?: Array<{ __typename?: 'Rental', id: string, createdAt?: any | null, isPromo?: boolean | null, isOnline?: boolean | null, type: string, name?: string | null, regionId?: string | null, capacity?: number | null, switchDay?: number | null, address?: { __typename?: 'Address', city?: string | null, countryId?: any | null } | null, reviews?: Array<{ __typename?: 'Review', name?: string | null, countryId?: string | null, textI18n?: any | null, score?: number | null, startDate?: any | null, endDate?: any | null } | null> | null } | null> | null } | null };

export type RemoveHouseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveHouseMutation = { __typename?: 'mutation', removeHouse?: boolean | null };

export type SpecialsQuery2QueryVariables = Exact<{ [key: string]: never; }>;


export type SpecialsQuery2Query = { __typename?: 'query', specials?: { __typename?: 'SpecialList', items?: Array<{ __typename?: 'Special', id: string, titleI18n?: any | null, icon?: string | null } | null> | null } | null };

export type ClientsQueryQueryVariables = Exact<{
  text?: InputMaybe<Scalars['ShortString']['input']>;
}>;


export type ClientsQueryQuery = { __typename?: 'query', clients?: { __typename?: 'ClientList', cursor?: string | null, total?: number | null, items?: Array<{ __typename?: 'Client', id: string, fullName?: string | null, email?: any | null, comms?: Array<{ __typename?: 'CommType', type?: string | null, data?: string | null, note?: string | null } | null> | null } | null> | null } | null };

export type AgentsQueryQueryVariables = Exact<{
  text?: InputMaybe<Scalars['ShortString']['input']>;
}>;


export type AgentsQueryQuery = { __typename?: 'query', agents?: { __typename?: 'AgentList', cursor?: string | null, total?: number | null, items?: Array<{ __typename?: 'Agent', id: string, name?: string | null, contacts?: Array<string | null> | null, hours?: string | null, margin?: number | null } | null> | null } | null };

export type HousesQueryQueryVariables = Exact<{
  text?: InputMaybe<Scalars['ShortString']['input']>;
}>;


export type HousesQueryQuery = { __typename?: 'query', fullHouses?: { __typename?: 'RentalList', cursor?: string | null, total?: number | null, items?: Array<{ __typename?: 'Rental', id: string, name?: string | null, agentRef?: string | null, placeName?: string | null } | null> | null } | null };

export type ContractsQueryQueryVariables = Exact<{
  text?: InputMaybe<Scalars['ShortString']['input']>;
}>;


export type ContractsQueryQuery = { __typename?: 'query', contracts?: { __typename?: 'ContractList', cursor?: string | null, total?: number | null, items?: Array<{ __typename?: 'Contract', id?: string | null, capId?: string | null, client?: { __typename?: 'Client', fullName?: string | null } | null } | null> | null } | null };

export const CommonFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CommonFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LandingPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urlI18n"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"houseId"}},{"kind":"Field","name":{"kind":"Name","value":"regionId"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"search"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"houseType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"features"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"specials"}}]}}]}}]} as unknown as DocumentNode<CommonFieldsFragment, unknown>;
export const BlogPostQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"blogPostQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"titleSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShortString"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blogPost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"titleSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"titleSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleI18n"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fallback"},"value":{"kind":"BooleanValue","value":false}}]},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"regionIds"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"w"}},{"kind":"Field","name":{"kind":"Name","value":"h"}},{"kind":"Field","name":{"kind":"Name","value":"blurhash"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"template"}}]}}]}}]} as unknown as DocumentNode<BlogPostQueryQuery, BlogPostQueryQueryVariables>;
export const FullBlogPostQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fullBlogPostQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isEditing"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blogPost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fallback"},"value":{"kind":"BooleanValue","value":false}}]},{"kind":"Field","name":{"kind":"Name","value":"titleI18n"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isEditing"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"summaryI18n"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isEditing"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"regionIds"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"w"}},{"kind":"Field","name":{"kind":"Name","value":"h"}},{"kind":"Field","name":{"kind":"Name","value":"blurhash"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"show"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"w"}},{"kind":"Field","name":{"kind":"Name","value":"h"}},{"kind":"Field","name":{"kind":"Name","value":"blurhash"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"template"}}]}}]}}]} as unknown as DocumentNode<FullBlogPostQueryQuery, FullBlogPostQueryQueryVariables>;
export const BlogPostsListQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"blogPostsListQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlyOnline"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"evenEmpty"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"regionIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShortString"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blogPosts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"onlyOnline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlyOnline"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"evenEmpty"},"value":{"kind":"Variable","name":{"kind":"Name","value":"evenEmpty"}}},{"kind":"Argument","name":{"kind":"Name","value":"regionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"regionIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fallback"},"value":{"kind":"BooleanValue","value":false}}]},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}}]}}]}}]}}]} as unknown as DocumentNode<BlogPostsListQueryQuery, BlogPostsListQueryQueryVariables>;
export const BlogPostsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"blogPostsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlyOnline"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"evenEmpty"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"regionIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShortString"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blogPosts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"onlyOnline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlyOnline"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"evenEmpty"},"value":{"kind":"Variable","name":{"kind":"Name","value":"evenEmpty"}}},{"kind":"Argument","name":{"kind":"Name","value":"regionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"regionIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fallback"},"value":{"kind":"BooleanValue","value":false}}]},{"kind":"Field","name":{"kind":"Name","value":"titleI18n"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"w"}},{"kind":"Field","name":{"kind":"Name","value":"h"}},{"kind":"Field","name":{"kind":"Name","value":"blurhash"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"template"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<BlogPostsQueryQuery, BlogPostsQueryQueryVariables>;
export const SaveBlogPostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"saveBlogPost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"titleI18n"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"I18nStringInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"summaryI18n"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"I18nStringInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isOnline"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"images"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ImageInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mainImage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ImageInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"regionIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShortString"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"template"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveBlogPost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}},{"kind":"Argument","name":{"kind":"Name","value":"titleI18n"},"value":{"kind":"Variable","name":{"kind":"Name","value":"titleI18n"}}},{"kind":"Argument","name":{"kind":"Name","value":"summaryI18n"},"value":{"kind":"Variable","name":{"kind":"Name","value":"summaryI18n"}}},{"kind":"Argument","name":{"kind":"Name","value":"isOnline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isOnline"}}},{"kind":"Argument","name":{"kind":"Name","value":"images"},"value":{"kind":"Variable","name":{"kind":"Name","value":"images"}}},{"kind":"Argument","name":{"kind":"Name","value":"mainImage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mainImage"}}},{"kind":"Argument","name":{"kind":"Name","value":"regionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"regionIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"template"},"value":{"kind":"Variable","name":{"kind":"Name","value":"template"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"titleI18n"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"w"}},{"kind":"Field","name":{"kind":"Name","value":"h"}},{"kind":"Field","name":{"kind":"Name","value":"blurhash"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"w"}},{"kind":"Field","name":{"kind":"Name","value":"h"}},{"kind":"Field","name":{"kind":"Name","value":"blurhash"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"regionIds"}}]}}]}}]} as unknown as DocumentNode<SaveBlogPostMutation, SaveBlogPostMutationVariables>;
export const RemoveBlogPostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeBlogPost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeBlogPost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RemoveBlogPostMutation, RemoveBlogPostMutationVariables>;
export const SaveBlogPostTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"saveBlogPostTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"template"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveBlogPostTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"template"},"value":{"kind":"Variable","name":{"kind":"Name","value":"template"}}}]}]}}]} as unknown as DocumentNode<SaveBlogPostTemplateMutation, SaveBlogPostTemplateMutationVariables>;
export const SaveBlockedRangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"saveBlockedRange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"blockedRange"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BlockedRangeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveBlockedRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"blockedRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"blockedRange"}}}]}]}}]} as unknown as DocumentNode<SaveBlockedRangeMutation, SaveBlockedRangeMutationVariables>;
export const RemoveBlockedRangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeBlockedRange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeBlockedRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RemoveBlockedRangeMutation, RemoveBlockedRangeMutationVariables>;
export const EmailPreviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"emailPreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"year"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ShortString"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailPreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}},{"kind":"Argument","name":{"kind":"Name","value":"agentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"year"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year"}}}]}]}}]} as unknown as DocumentNode<EmailPreviewQuery, EmailPreviewQueryVariables>;
export const SendEmailWithMandrillDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendEmailWithMandrill"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EmailInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendEmailWithMandrill"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}]}}]} as unknown as DocumentNode<SendEmailWithMandrillMutation, SendEmailWithMandrillMutationVariables>;
export const SendEmailAgainDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendEmailAgain"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendEmailAgain"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<SendEmailAgainMutation, SendEmailAgainMutationVariables>;
export const LandingPageByUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"landingPageByUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShortString"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShortString"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"landingPageByUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}},{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metaDesc"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CommonFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CommonFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LandingPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urlI18n"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"houseId"}},{"kind":"Field","name":{"kind":"Name","value":"regionId"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"search"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"houseType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"features"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"specials"}}]}}]}}]} as unknown as DocumentNode<LandingPageByUrlQuery, LandingPageByUrlQueryVariables>;
export const LandingPageByUrlAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"landingPageByUrlAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShortString"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShortString"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"landingPageByUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}},{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}},{"kind":"Argument","name":{"kind":"Name","value":"followRedirects"},"value":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"metaDescI18n"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywordsI18n"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitleI18n"}},{"kind":"Field","name":{"kind":"Name","value":"redirectId"}},{"kind":"Field","name":{"kind":"Name","value":"redirectUrlI18n"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CommonFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CommonFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LandingPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urlI18n"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"houseId"}},{"kind":"Field","name":{"kind":"Name","value":"regionId"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"search"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"houseType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"features"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"specials"}}]}}]}}]} as unknown as DocumentNode<LandingPageByUrlAdminQuery, LandingPageByUrlAdminQueryVariables>;
export const LandingPageAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"landingPageAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"landingPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"metaDescI18n"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywordsI18n"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitleI18n"}},{"kind":"Field","name":{"kind":"Name","value":"redirectId"}},{"kind":"Field","name":{"kind":"Name","value":"redirectUrlI18n"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CommonFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CommonFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LandingPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urlI18n"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"houseId"}},{"kind":"Field","name":{"kind":"Name","value":"regionId"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"search"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"houseType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"features"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"specials"}}]}}]}}]} as unknown as DocumentNode<LandingPageAdminQuery, LandingPageAdminQueryVariables>;
export const LandingPagesAdminQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"landingPagesAdminQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlyOnline"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"landingPagesAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"onlyOnline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlyOnline"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"redirectId"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitleI18n"}},{"kind":"Field","name":{"kind":"Name","value":"redirectUrlI18n"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CommonFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CommonFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LandingPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urlI18n"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"houseId"}},{"kind":"Field","name":{"kind":"Name","value":"regionId"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"search"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"houseType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"features"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"specials"}}]}}]}}]} as unknown as DocumentNode<LandingPagesAdminQueryQuery, LandingPagesAdminQueryQueryVariables>;
export const SaveLandingPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"saveLandingPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"landingPage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LandingPageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveLandingPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"landingPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"landingPage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urlI18n"}},{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"houseId"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"metaDescI18n"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywordsI18n"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitleI18n"}},{"kind":"Field","name":{"kind":"Name","value":"redirectId"}},{"kind":"Field","name":{"kind":"Name","value":"redirectUrlI18n"}},{"kind":"Field","name":{"kind":"Name","value":"search"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"houseType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"features"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"specials"}}]}}]}}]}}]} as unknown as DocumentNode<SaveLandingPageMutation, SaveLandingPageMutationVariables>;
export const SubscribeToNewsletterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"subscribeToNewsletter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscribeToNewsletter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subscriber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriber"}}}]}]}}]} as unknown as DocumentNode<SubscribeToNewsletterMutation, SubscribeToNewsletterMutationVariables>;
export const FullHouseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fullHouse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullHouse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"agentChanges"}}]}}]}}]} as unknown as DocumentNode<FullHouseQuery, FullHouseQueryVariables>;
export const UploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"upload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"meta"}}]}}]}}]} as unknown as DocumentNode<UploadQuery, UploadQueryVariables>;
export const SpecialsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"specialsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<SpecialsQueryQuery, SpecialsQueryQueryVariables>;
export const AllHousesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allHouses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isOnline"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featuresAllIn"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullHouses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"isOnline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isOnline"}}},{"kind":"Argument","name":{"kind":"Name","value":"featuresAllIn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featuresAllIn"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isPromo"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"regionId"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"countryId"}},{"kind":"Field","name":{"kind":"Name","value":"textI18n"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"switchDay"}}]}}]}}]}}]} as unknown as DocumentNode<AllHousesQuery, AllHousesQueryVariables>;
export const RemoveHouseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeHouse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeHouse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RemoveHouseMutation, RemoveHouseMutationVariables>;
export const SpecialsQuery2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"specialsQuery2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleI18n"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}}]}}]}}]} as unknown as DocumentNode<SpecialsQuery2Query, SpecialsQuery2QueryVariables>;
export const ClientsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"clientsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ShortString"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clients"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"5"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"comms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<ClientsQueryQuery, ClientsQueryQueryVariables>;
export const AgentsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"agentsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ShortString"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"5"}},{"kind":"Argument","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"margin"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<AgentsQueryQuery, AgentsQueryQueryVariables>;
export const HousesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"housesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ShortString"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullHouses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"5"}},{"kind":"Argument","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"agentRef"}},{"kind":"Field","name":{"kind":"Name","value":"placeName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<HousesQueryQuery, HousesQueryQueryVariables>;
export const ContractsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"contractsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ShortString"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contracts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"5"}},{"kind":"Argument","name":{"kind":"Name","value":"capId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"capId"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<ContractsQueryQuery, ContractsQueryQueryVariables>;